import React, {useRef} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getPropertyTypesFilterVisibility} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {searchParamToFacet} from 'modules/search/constants'
import {FilterUrlParam} from 'modules/search/types'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {PropertyTypeFilterBottomSheetContentLoadable} from './Loadable'

export const PropertyTypeFilterBottomSheet = () => {
  const dispatch = useDispatch()
  const {formatMessage} = useIntl()

  // Store the facetKey in a ref to simulate an instance variable that won't change when the component re-renders
  // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
  const facetFilterKeys = useRef([searchParamToFacet.propertyTypes.param])
  const {
    submitFilters,
    getFilters,
    clearFilters,
    resetFilters,
    calculateIfFiltersChanged,
    getAppliedFilters,
    toggleMultiFilter,
    setMultiFilters,
    removeMultiFilters
  } = useFiltersForm(facetFilterKeys.current)

  const isOpen = useSelector(getPropertyTypesFilterVisibility)
  const facetFilterKey = facetFilterKeys.current[0]
  const facetFilter = getFilters()[facetFilterKey] as FilterUrlParam
  const appliedFacetFilter = getAppliedFilters()[facetFilterKey]

  const handleApply = () => {
    if (calculateIfFiltersChanged(getFilters())) {
      submitFilters()
    } else {
      dispatch(hideOverlay())
    }
  }

  const handleClear = () => {
    if (facetFilter) {
      clearFilters()
    } else {
      dispatch(hideOverlay())
    }
  }

  const handleClose = () => {
    resetFilters()
    dispatch(hideOverlay())
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      navBarProps={{
        centerContent: formatMessage(filterMessages.propertyType)
      }}
      snapPoints={{top: 'full', middle: 0.95}}
      withDragHandler
      bottomBarContent={
        <Box
          display="flex"
          justifyContent="space-between"
          data-id="propertyTypeFilterBottomSheetButtons"
        >
          <Button
            dataId="clearFiltersButton"
            onClick={handleClear}
            variant="tertiary"
          >
            <FormattedMessageWrapper id="clear" defaultMessage="Clear" />
          </Button>
          <Button dataId="applyFiltersButton" onClick={handleApply}>
            <FormattedMessageWrapper id="apply" defaultMessage="Apply" />
          </Button>
        </Box>
      }
    >
      {isOpen && (
        <PropertyTypeFilterBottomSheetContentLoadable
          facetFilter={facetFilter}
          appliedFacetFilter={appliedFacetFilter}
          toggleMultiFilter={toggleMultiFilter}
          setMultiFilters={setMultiFilters}
          removeMultiFilters={removeMultiFilters}
        />
      )}
    </BottomSheet>
  )
}
